import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {HiperioUserJob} from "../interface/hiperio-user-job";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first} from "rxjs/operators";
import {HiperioCredentialsJob} from "../interface/hiperio-credentials-job";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class HiperioCredentialsJobsService {
  public readonly jobListSubject: ReplaySubject<CountedAndPaginated<HiperioCredentialsJob>>
    = new ReplaySubject<CountedAndPaginated<HiperioCredentialsJob>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadJobList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/hiperio/credentials-job?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<HiperioCredentialsJob>) => {
        this.jobListSubject.next(result);
      });
  }
  public restart(uuid: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/hiperio/credentials-job/${uuid}/restart`, {})
      .pipe(first());
  }

  public downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/credentials-job/mixed-accesses/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

}
